import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";

export default function AddSubject() {

    const [subject, setSubject] = useState();
    const navigate = useNavigate();
    const adminToken = localStorage.getItem("authAdminToken");


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!subject) {
            toast.info("Subject field is required.");
            return;
        }

        const sub_data = {
            subject: subject,
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/createSubject`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${adminToken}`
                },
                body: JSON.stringify(sub_data),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Subject add successfully!");
                setSubject("");
            } else {
                toast.error("Failed to add subject. Please try again.");
                navigate('/admin/addsubject');
            }

        } catch (error) {
            toast.error("An error occurred while adding the language. Please try again later.");
        }
    };


    return (
        <>

            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            <div className="container-xxl flex-grow-1 container-p-y" style={{ margin: "4em 42em" }}>
                <div className="app-ecommerce">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="card mb-6">
                                <div className="card-header">
                                    <h5 className="card-tile mb-0">Add Subject Master</h5>
                                </div>
                                <div className="card-body">

                                    <form onSubmit={(event) => { handleSubmit(event) }}>
                                        <div className="row gx-5 mb-5">
                                            <div className="col">
                                                <div className="form-floating form-floating-outline">
                                                    <input type="text" className="form-control" value={subject} onChange={(event) => { setSubject(event.target.value) }} placeholder="Enter Language" />
                                                    <label htmlFor="language">Subject</label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-3 d-flex gap-4 mx-4">
                                            <button type="submit" class="btn btn-primary">Add</button>

                                        </div>

                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
